module.exports = __webpack_public_path__ + "img/10_23.299d399b.png";